import { useMemo } from 'react';
import { useAppSelector } from '@/shared/model';
import { selectIntegrations } from './slice';
import type { Datasource, Integration } from './types';
import { IntegrationStatus } from './types';

export function useDatasourceIntegrations(
  datasource: Datasource,
): Integration[] {
  const integrations = useAppSelector(selectIntegrations);

  return useMemo(() => {
    const sourceIds = new Set(datasource.sourceIntegrationIds);

    return integrations
      .filter((integration) => sourceIds.has(integration.sourceIntegrationId))
      .sort((a, b) => {
        const aFailed = a.status === IntegrationStatus.failed;
        const bFailed = b.status === IntegrationStatus.failed;

        if (aFailed && !bFailed) return -1;
        if (!aFailed && bFailed) return 1;

        return 0;
      });
  }, [integrations, datasource.sourceIntegrationIds]);
}
